import './main-loader.scss';

import { Spin } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface IProps {
  /** Растянуть на ширину родителя и отцентрировать. */
  fullWidth?: boolean;
  /** Оверлей на всё окно. */
  fullScreen?: boolean;
  /** Размыть контент под оверлеем. */
  blur?: boolean;
  /** Оверлей на область контента каркаса. */
  layout?: boolean;
}

/** Индикатор загрузки экрана или его части: antd Spin, при необходимости — на оверлее. */
const MainLoader: React.FC<IProps> = ({
  fullWidth,
  fullScreen,
  blur,
  layout
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('main-loader', {
        'main-loader--full-width': fullWidth,
        'main-loader--fullscreen': fullScreen,
        'main-loader--blur-mode': blur,
        'main-loader--layout': layout
      })}
      role="status"
      aria-label={t('common.loading')}
    >
      <Spin size="large" />
    </div>
  );
};

export default MainLoader;
